<template>
  <div class="laboratory_knowledge">
    <van-nav-bar title="检测常识" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="检测常识" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="swine_wrap">
        <van-collapse v-model="activeNames">
            <van-collapse-item :title="index + 1 + '、' +item.title" :name="index" v-for="(item,index) in contentList" :key="index">
                <p>{{item.textItem}}</p>
                <div :style="item.list && item.list.length != 0 ? 'padding-top:10px;':''">
                    <p v-for="(ele,i) in item.list" :key="i" style="line-height:22px;">
                      <span style="font-weight: 600;display:block;">{{ele.title}}：</span>
                      <span style="color:#4C4C4C;">{{ele.textItem}}</span>
                    </p>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/top.vue'
export default {
  name: 'laboratoryknowledge',
  components: {
    Top
  },
  data(){
    return{
      btnFlag:false,
      activeNames:[0],
      contentList:[
        {
          title:'抗原',
          textItem:'抗原是能够刺激机体产生免疫应答，并能与免疫应答产物发生特异性结合的物质。抗原可分为外来的和自身的两种。一般抗原都是外来物质，如细菌、病毒、寄生虫等。',
        },
        {
          title:'抗体',
          textItem:'抗原刺激相应B细胞克隆增殖分化为浆细胞后分泌的一种在体内、体外都能与相应抗原特异性结合的免疫球蛋白。',
        },
        {
          title:'PCR',
          textItem:'PCR技术是模拟体内DNA的天然复制过程，在体外扩增DNA分子的一种分子生物学技术，主要用于扩增位于两段已知序列之间的DNA区段。在待扩增的DNA片段两侧和与其两侧互补的两个寡核苷酸引物，经变性、退火和延伸若干个循环后，DNA扩增2ⁿ倍。',
        },
        {
          title:'RT-PCR',
          textItem:'反转录PCR（Reverse Transcription，RT-PCR）又称为逆转录PCR，是指以RNA为模板，合成与其互补的cDNA的过程。逆转录PCR是将RNA的逆转录（reverse transcription）和cDNA的聚合酶链式反应（PCR）相结合的技术，故逆转录称为 RT-PCR 或反转录 PCR。',
        },
        {
          title:'实时荧光定量PCR',
          textItem:'荧光定量PCR（Realtime fluorescence quantitative PCR，qPCR）也称作实时荧光定量PCR。它是指在PCR反应体系中加入荧光基团，利用荧光信号累积实时检测整个PCR进程，最后通过标准曲线对初始模板进行定量分析的方法。其原理是在PCR反应体系中加入荧光基团，随着PCR反应的进行，PCR反应产物不断累积，荧光信号强度也等比例增加。每经过一个循环收集一个荧光强度信号，通过荧光强度变化检测产物量的变化，最终得到一条荧光扩增曲线图，扩增曲线横坐标表示循环数，纵坐标表示荧光强度。',
        },
        {
          title:'抗原与抗体反应原理',
          textItem:'抗原抗体反应指抗原与相应抗体之间所发生的特异性结合反应，这种反应既可在机体内进行，也可以在机体外进行。抗原抗体的特异性是指抗原分子上的抗原决定簇和抗体分子高变区结合的特异性，由两者之间结构互补决定的。因此，在抗原抗体反应的免疫学实验中，可以用已知的抗原或抗体来检测相应的抗体或抗原。但较大分子的蛋白质常含有多种抗原表位。如果两种不同的抗原分子上有相同的抗原表位，或抗原、抗体间构型部分相同，皆可出现交叉反应。',
        },
        {
          title:'血凝试验',
          textItem:'某些病毒如鸡新城疫病毒、禽流感病毒、鸡减蛋综合征病毒、兔出血症病毒等具有能凝集某种哺乳动物类和禽类红细胞的特性，依此特性建立的检测方法称为病毒血凝实验（haemagglutination assay, HA）。',
        },
        {
          title:'血凝抑制试验',
          textItem:'某些病毒具有能凝集某种哺乳动物类和红细胞的特性，针对以上病毒的特异性抗体可以抑制这种反应，依此特性建立的检测方法称为病毒的血凝抑制试验（haemagglutination inhibition assay, HI）。',
        },
        {
          title:'正向间接凝集试验',
          textItem:'正向间接凝集试验的原理是将可溶性抗原吸附于与免疫无关的载体（红细胞）表面，此吸附抗原的红细胞与相应的抗体结合，在有电解质存在的适宜条件下发生的肉眼可见的凝集性反应。临床上常用于猪瘟、口蹄疫等疫病的检测。用已知抗原检测未知抗体称之为正向间接凝集试验，用已知抗体检测未知抗原称之为反向间接凝集试验。',
        },
        {
          title:'平板凝集试验',
          textItem:'颗粒性抗原（细菌、螺旋体、红细胞等）与相应的抗体血清混合后，在电解质参与下，经过一定时间，抗原抗体凝聚成肉眼可见的凝集块，这种现象称为凝集反应。参与反应的抗原称为凝集原（Agglutinogen），参与反应的血清中的抗体称为凝集素（Agglutinin）。细菌或其他凝集原都带有相同的电荷（负电荷），在悬液中相互排斥而呈均匀的分散状态。抗原与抗体相遇后，由于抗原和抗体分子表面存在着相互对应的化学基团，因而发生特异性结合，成为抗原抗体复合物。由于抗原与抗体结合，降低了抗原分子间的静电排斥力，抗原表面的亲水基团减少，由亲水状态变为疏水状态，此时已有凝集的趋向，在电解质（如生理盐水）参与下，由于离子的作用，中和了抗原抗体复合物外面的大部分电荷，使之失去了彼此间的静电排斥力，分子间相互吸引，凝集成大的絮片或颗粒。出现了肉眼可见的凝集反应。',
        },
        {
          title:'虎红平板凝集试验',
          textItem:'虎红平板凝集试验是抗原抗体在体外发生特异性结合并呈现眼观可见反应，采用酸性（pH3.6~3.9）带色的抗原与被检血清作用，通过抑制血清中的IgM类抗体的凝集活性并检IgG类抗体。该法广泛应用于畜间布氏杆菌病的血请学检测，该法敏感性高，特异性强，价格便宜，操作简便，检测快速，易于判定结果。在国际贸易中是牛、羊、猪布鲁氏菌病检测的指定试验，适用于在布氏杆菌病的大规模监测中初筛阳性畜，在我国也用于人布鲁氏菌病监测的初筛。',
        },
        {
          title:'试管凝集试验',
          textItem:'布鲁氏杆菌病试管凝集试验通过倍比稀释待检血清，并加入已知颗粒性抗原来进行凝集反应，用于定量检测抗体。该法广泛应用于畜间布氏杆菌病的血请学检测，是一种特异、较敏感、稳定的检测方法，主要检测血清中的抗布鲁氏菌IgG、IgM型抗体，可作为布鲁氏菌病的早期诊断，同时又可用于牲畜布鲁氏菌病疫苗免疫后血清抗体的检测。在国际贸易中是牛、羊、猪布鲁氏菌病检测的指定试验，在我国也用于人布鲁氏菌病监测的筛查。',
        },
        {
          title:'间接ELISA',
          textItem:'将特异性抗原包被在96孔酶标板上。反应过程中，将待检样品加入酶标孔，样品中的特异性抗体会与孔中包被的特异性抗原反应，形成抗原-抗体复合物，在洗板的过程中不会被清洗掉。当添加酶标二抗时，酶标二抗会与抗原-抗体复合物结合，没有结合的酶标二抗在洗板的过程中被清洗。加入TMB底物后，如果有特异性抗体存在，则显色。颜色强度与样品中的抗体浓度呈正相关。',
        },
        {
          title:'竞争ELISA',
          textItem:'竞争法一般用于检测无法同时与两种抗体结合的小分子抗原，其原理为：将抗原包被在酶标板上，检测时加入待测样本，使样本中的待测抗体与酶标板上的抗原结合。然后加入HRP酶标记的抗体，此抗体也可与酶标板上的抗原结合，由于酶标板上固著的抗原数量有限，因此当样本中抗体的量越多，则HRP酶标记抗体可结合的包被抗原就越少，两种抗体竞争结合包被抗原，所以称为竞争法。接着加入HRP酶的底物TMB，TMB被酶催化发生颜色反应，当样本中抗体量越多，代表酶标板孔内留下的HRP标记抗体越少，显色也就越浅。',
        },
        {
          title:'琼脂扩散试验',
          textItem:'利用可溶性抗原与抗体在半固体琼脂内进行扩散，若抗原与抗体对应，并且比例适当，就会出现白色沉淀线，此为阳性反应。琼脂扩散试验可在试管内、平皿中以及玻片上的琼脂中进行。又可分为单向琼脂扩散试验和双向琼脂扩散试验两类。单向琼脂扩散试验是一种常用的定量检测抗原的方法。将适量抗体与琼脂混匀，浇注成板，凝固后，在板上打孔，孔中加入抗原，抗原就会向孔的四周扩散，边扩散边与琼脂中的抗体结合。一定时间后，在两者比例适当处形成白色沉淀环。沉淀环的直径与抗原的浓度成正比。如事先用不同浓度的标准抗原制成标准曲线，则从曲线中可求出标本中抗原的含量。双向琼脂扩散试验是将半固体琼脂倾注于平皿内或玻片上，待其凝固后，在琼脂板上打孔，将抗原、抗体分别注入小孔内，使两者相互扩散。如果抗原、抗体相互对应，浓度、比例适当，则一定时间后，在抗原、抗体孔之间出现清晰可见的沉淀线。双向琼脂扩散法可用来分析溶液中的多种抗原。一对抗原、抗体系统只能形成一条沉淀线，不同的抗原抗体系统在琼脂中扩散的速度不同，可在琼脂中形成不同的沉淀线。',
        },
        {
          title:'对流免疫电泳',
          textItem:'对流免疫电泳又叫反向免疫电泳或免疫电渗电泳。其原理：带电的胶体颗粒可在电场中移动，其移动方向与胶体颗粒所带电荷有关。在pH值8.6的琼脂凝胶中，抗体球蛋白只带有微弱的负电荷，而且它分子又较大，所以泳动慢，受电渗作用的影响也大，往往不能抵抗电渗作用，故在电泳时，反而向负极倒退。而一般抗原蛋白质常带较强的负电荷，分子又较小，所以泳动快，虽然由于电渗作用泳动速度减慢，但仍能向正极泳动。如将抗原置阴极，抗体置阳极，电泳时，两种成分相对泳动，一定时间后抗原和抗体将在两孔之间相遇，并在比例适当的地方形成肉眼可见的沉淀线。这样由于电泳的作用，不仅帮助抗体定向移动，因而加速了反应的出现，而且也限制了琼脂扩散时，抗原抗体向四周自由扩散的倾向，因而也提高了敏感性，本法比琼脂扩散法的灵敏度要高10~16倍，而且反应时间短，可用于各种蛋白的定性和半定量测定。',
        },
        {
          title:'胶体金试验',
          textItem:'胶体金是氯金酸在还原剂作用下，聚合成一定大小的金颗粒，形成带负电荷的疏水胶溶液。胶体金颗粒表面负电荷与蛋白质的正电荷基团因静电吸附而形成牢固结合。胶体金对蛋白质有很强的吸附功能，蛋白质等高分子被吸附到胶体金颗粒表面，无共价键形成，标记后大分子物质活性不发生改变。在胶体金免疫层析法中，将特异性的抗原或抗体以条带状固定在硝酸纤维素膜上，将胶体金标记试剂吸附到结合垫上。将待测样品放在样品垫上后，通过毛细作用向前移动，并与胶体金标记相互反应，反应之后再移动到固定的抗原或者是抗体的区域的时候，待检样品与金标试剂的结合物会与抗原或者是抗体发生特异性反应，反应之后的生成物就会停留在检测带上，会显出一定的条带，这样，通过反应之后的胶体金标记物的显色情况就可以得到想要的结果。',
        },
        {
          title:'免疫酶试验',
          textItem:'免疫酶试验是最常用的免疫细胞化学技术，它把抗原抗体的免疫反应和酶的高效催化作用有效地结合起来。一般由两部分组成，即一次或数次抗原和抗体的免疫学反应和一次酶促反应。第一步抗原抗体结合中，酶结合物起抗体作用，在第二步加入底物后，酶起到了催化的生物放大作用。该方法具有敏感性高，标本可长期保存，使用一般光学显微镜就能观察等优点，但有时也存在非特异性染色的问题。',
        },
        {
          title:'免疫酶组织化学技术',
          textItem:'免疫组织化学又称免疫细胞化学，是指带显色剂标记的特异性抗体在组织细胞原位通过抗原 抗体反应和组织化学的呈色反应，对相应抗原进行定性、定位、定量测定的一项新技术。它把免疫反应的特异性、组织化学的可见性巧妙地结合起来，借助显微镜（包括荧光显微镜、电子显微镜）的显像和放大作用，在细胞、亚细胞水平检测各种抗原物质（如蛋白质、多肽、酶、激素、病原体以及受体等）。',
        },
        {
          title:'HE染色',
          textItem:'即苏木精－伊红染色法( hematoxylin-eosin staining )，是石蜡切片技术里常用的染色法之一。苏木精染液为碱性，主要使细胞核内的染色质与胞质内的核糖体着紫蓝色；伊红为酸性染料，主要使细胞质和细胞外基质中的成分着红色。',
        },
        {
          title:'细菌分离划线培养',
          list:[
            {title:'(1)',textItem:'斜面接种法是在固体培养基斜面上移种纯种细菌，常作为菌种传代和观察细菌某些生化反应用，如尿素分解试验和枸橼酸盐利用试验。'},
            {title:'(2)',textItem:'半固体培养基接种法，也称穿刺接种法，是使用接种针在半固体培养基表面中心位置，沿中轴方向垂直刺入培养基至3/4深度进行接种。用于细菌动力观察、保存菌种及观察某些细菌生化反应（醋酸铅试验和明胶液化试验等）。'},
            {title:'(3)',textItem:'液体培养基如消化肉汤、蛋白胨水、单糖发酵管等，可应用于细菌的增菌或细菌生化反应。不同的细菌在液体培养基内可呈现不同生长现象，主要有混浊生长、沉淀生长和菌膜（状）生长。'}
          ],
          textItem:'细菌分离培养法也叫细菌分离接种技术，即应用接种环将细菌在固体培养基平板上划线接种，将混杂细菌逐一分散成单个，经培养后各自形成单个菌落，将单个菌落移种增殖后可得到纯种细菌。在分离出单个菌落的基础上，将某纯种细菌移种增殖称细菌纯培养。细菌纯培养接种技术按使用培养基的固体、半固体和液体状态，可分为平板接种法、斜面接种法、半固体接种法和液体接种法。',
        },
        {
          title:'革兰氏染色',
          textItem:'革兰氏染色法是细菌中广泛使用的重要鉴别方法。通过这种染色方法，可以将细菌分为革兰氏阳性细菌（G+）和革兰氏阴性细菌（Gˉ）。革兰染色法一般包括初染、媒染、脱色、复染等四个步骤。未经染色的细菌，由于其与周围环境折光率差别甚小，故在显微镜下极难区别。经染色后，阳性菌呈紫色，阴性菌呈红色，可以清楚地观察到细菌的形态、排列及某些结构特征，从而用以分类鉴定。',
        },
        {
          title:'药敏实验',
          textItem:'将抗菌药物置于已接种待测细菌的固体培养基上，抗菌药物通过向培养基内扩散，抑制敏感菌的生长，从而出现抑菌圈。药物扩散的距离越远，达到该距离的药物浓度就越低，故可根据抑菌环的大小，判断细菌对药物的敏感度。抑菌环边缘药物的含量就是该药物的敏感度。但因含药量和接种量等多种因素影响结果不稳定，因此试验时应同时设立已知敏感度的质控菌株作为对照。',
        },
        {
          title:'饱和食盐水漂浮法',
          textItem:'饱和食盐水的比重大约为1.2，比重较小的虫卵能够漂浮在溶液表面，从而达到分离和浓集的目的。适用于线虫卵（未受精蛔虫卵除外）和绦虫卵，检查钩虫卵效果尤佳，但不适宜检查吸虫卵和原虫包囊。',
        },
        {
          title:'清水沉淀法',
          textItem:'清水沉淀法适合检查各种虫卵，尤其是比重大的虫卵。粪便捣碎经过滤后，加入清水，静置20分钟后倾去上清，如此反复3次，取底部沉淀镜检。',
        },
        {
          title:'细菌内毒素检测',
          textItem:'内毒素是革兰氏阴性菌细胞壁中的脂多糖（lipopolysaccharide，LPS）成分，而类脂 A是其活性部分，个别革兰氏阳性菌也含有内毒素；螺旋体、衣原体、立克次氏体亦含有 LPS，具有内毒素活性。内毒素在细菌生活时不释放到环境中，只是在菌体自溶或用人工方法使细菌裂解后才释放出来。其性质较稳定，耐热、抗原性不强，相对分子质量大于10万，不同细菌的内毒素引起机体产生的症状基本相同，如发热、白细胞减少，微循环病变及休克等。内毒素的检测过去用家兔发热法，由于易受动物个体及环境因素的影响，现已被鲎试验所取代。鲎试剂是美洲堂或东方堂的血细胞中提取的水状物。内毒素激活鲎试剂中的一个因子并引发蛋白级联反应。其中一个活化因子将凝固酶原激活为凝固酶，凝固酶催化鲎试剂中的凝固蛋白原转化为凝固蛋白，并通过二硫键自然地彼此结合，形成鲎试剂的混浊并最终形成凝胶。',
        },

      ],
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      isWx: 1,
    }
  },
  
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<style lang="scss">
.laboratory_knowledge{
    text-align: left !important;
    .van-nav-bar .van-icon{
        color: #999999;
    }
    .van-cell{
      color:#4C4C4C !important;
      font-size:16px !important;
      font-weight: 600 !important;
    }
    .van-collapse-item__content{
      color:#4C4C4C !important;
      font-size:14px !important;
      background:rgba(245,245,245,1) !important;
    }
    .content{
        padding: 15px 14px 10px;
        font-family:PingFangSC-Regular;
        line-height:24px;
        color:rgba(32,32,32,1);
        opacity:1;
    }
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
</style>
